"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93049],{

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical
    };
}).withConfig({
    componentId: "sc-fadbb486-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 97214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var withSpacing = function(Component) {
    return function(props) {
        var spacing = (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props);
        var WithSpacingComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Component).attrs(function(componentProps) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, componentProps, spacing);
        }).withConfig({
            componentId: "sc-bfeb3364-0"
        })(_templateObject1(), function(componentProps) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(componentProps));
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WithSpacingComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withSpacing);


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 89999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ HumbergerButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97214);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      color: ",
        ";\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ,\n        :hover {\n          background: ",
        ";\n          color: ",
        ";\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n    border: none;\n    border-bottom: 1px solid ",
        ";\n    :hover,\n    :focus {\n      border-color: ",
        ";\n      color: ",
        ";\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-radius: ",
        ";\n    height: ",
        ";\n    margin: ",
        ";\n    padding: ",
        ";\n    \n    ::after{\n      content: unset;\n    }\n    \n    ",
        ";\n    border : ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ';\n      position: relative;\n      ::after {\n        content: "";\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        height: 2px;\n        background: ',
        ";\n      }\n      span:nth-child(1) {\n        transform: rotate(45deg);\n        position: relative;\n        top: 5px;\n      }\n      span:nth-child(2) {\n        display: none;\n      }\n      span:nth-child(3) {\n        transform: rotate(-45deg);\n        position: relative;\n        bottom: 0;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  \n  span {\n    display: block;\n    height: 1px;\n    width: 16px;\n    background: ",
        ";\n    margin: 4px auto 0;\n    transition : 0.3s;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var buttonType = {
    sunsetOrange: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange),
    highempahis: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis),
    defaultHoverable: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary),
    widget: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject6(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis, function(param) {
        var active = param.active;
        return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].aliceBlue */ .Z.aliceBlue, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
    })
};
var ButtonCustom = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo((0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "round",
            "active",
            "borderLess"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        height: props.height || "auto",
        type: props.type || "default",
        round: props.round,
        active: props.active,
        borderLess: props.borderLess,
        margin: props.margin || "0 !important",
        padding: props.padding || "4px 15px"
    };
}).withConfig({
    componentId: "sc-6d94ba47-0"
})(_templateObject7(), function(param) {
    var round = param.round;
    return round ? "2px" : "0px";
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var type = param.type;
    return buttonType[type];
}, function(param) {
    var borderLess = param.borderLess;
    return borderLess && "none";
}));
var HumbergerButtonComp = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "active"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        active: props.active
    };
}).withConfig({
    componentId: "sc-6d94ba47-1"
})(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dimgray */ .Z.dimgray, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
});
var HumbergerButton = function(_param) /*#__PURE__*/ {
    var className = _param.className, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HumbergerButtonComp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
        ]
    }));
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,_hoc_withSpacing__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ButtonCustom));


/***/ }),

/***/ 28471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99890);


function Template(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .TemplateLayout */ .fM, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .TemplateHeader */ .HZ, {
                justify: "center",
                align: "center",
                children: "External Community"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .TemplateContent */ .qz, {
                children: children
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Template);


/***/ }),

/***/ 36160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features_community; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Loading/PrimarySpinner.tsx
var PrimarySpinner = __webpack_require__(32253);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/ModalShare/index.tsx + 9 modules
var ModalShare = __webpack_require__(41232);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/lib/api/community.ts
var community = __webpack_require__(89561);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(66350);
;// CONCATENATED MODULE: ./src/features/community/hooks/useLeaveCommunity.ts





function useLeaveCommunity() {
    var mutation = (0,useMutation/* useMutation */.D)({
        mutationFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,community/* deleteReferral */.By)();
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Something is terribly wrong, please contact our administrator");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data.message);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,errors/* errorHandler */.P)(_ctx.t0, "Failed to leave community, unhandled error");
                        return _ctx.abrupt("return", undefined);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        })),
        retry: false
    });
    return mutation;
}
/* harmony default export */ var hooks_useLeaveCommunity = (useLeaveCommunity);

;// CONCATENATED MODULE: ./src/features/community/__tests__/constant.ts
var DATA_CY_COMMUNITY = "community";
var DATA_CY_JOIN_COMMUNITY = "join-community";

// EXTERNAL MODULE: ./src/features/community/analytics.ts
var analytics = __webpack_require__(20826);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/styled.ts
var styled = __webpack_require__(73164);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/features/community/styled.ts
var community_styled = __webpack_require__(99890);
;// CONCATENATED MODULE: ./src/features/community/components/Fieldset.tsx






function Fieldset(param) {
    var fee = param.fee, community = param.community, communityFee = param.communityFee, withProfile = param.withProfile;
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), _data = ref.data, phone = _data.phone, username = _data.username;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* FieldsetWrapper */.CG, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "flex-start",
                mb: "12px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Komunitas"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: community === null || community === void 0 ? void 0 : community.name
                    })
                ]
            }),
            withProfile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "flex-start",
                        mb: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Stockbit Username"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: username
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "flex-start",
                        mb: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "No. HP"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: phone
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "flex-start",
                mb: "12px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Total Fee Beli"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: communityFee ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "grey line-through",
                                    children: [
                                        (fee === null || fee === void 0 ? void 0 : fee.total_buy) || 0,
                                        "%"
                                    ]
                                }),
                                " → ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "".concat((communityFee === null || communityFee === void 0 ? void 0 : communityFee.total_buy) || 0, "%")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "".concat((fee === null || fee === void 0 ? void 0 : fee.total_buy) || 0, "%")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "flex-start",
                // @ts-expect-error
                mb: communityFee ? "12px" : "0px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Total Fee Jual"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: communityFee ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "grey line-through",
                                    children: [
                                        (fee === null || fee === void 0 ? void 0 : fee.total_sell) || 0,
                                        "%"
                                    ]
                                }),
                                " → ",
                                "".concat((communityFee === null || communityFee === void 0 ? void 0 : communityFee.total_sell) || 0, "%")
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: "".concat((fee === null || fee === void 0 ? void 0 : fee.total_sell) || 0, "%")
                        })
                    })
                ]
            }),
            communityFee ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "span",
                size: "12px",
                height: "16px",
                color: "rgba(150, 150, 150, 1)",
                children: "Fee baru berlaku efektif satu hari setelah aktivasi kode."
            }) : null
        ]
    });
}
/* harmony default export */ var components_Fieldset = (Fieldset);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/features/community/components/Info.tsx





function Info(param) {
    var until = param.until;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* InfoWrapper */.mo, {
        p: "12px 16px",
        align: "center",
        justify: "flex-start",
        mt: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: "info",
                src: "/images/community/info.svg",
                width: "16px",
                height: "16px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                ml: "8px",
                size: "12px",
                height: "16px",
                as: "span",
                children: [
                    "Kode komunitas tidak dapat diubah atau dihapus selama tiga bulan setelah aktivasi hingga",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        size: "12px",
                        height: "16px",
                        family: "bold",
                        as: "span",
                        children: [
                            moment_default()(until).format("DD MMM YYYY"),
                            "."
                        ]
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var components_Info = (Info);

// EXTERNAL MODULE: ./src/lib/api/chat.ts
var chat = __webpack_require__(69101);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware/immer.js
var immer = __webpack_require__(42435);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
;// CONCATENATED MODULE: ./src/features/community/hooks/useShareReceipt.ts







var useShareReceipt = (0,esm/* default */.ZP)((0,immer/* immer */.n)(function(set, get) {
    return {
        isShareModalVisible: false,
        recipientName: null,
        message: null,
        showShareModal: function showShareModal(recipientName, communityName, username, phone) {
            set(function(draft) {
                draft.isShareModalVisible = true;
                draft.recipientName = recipientName;
                // compose message
                draft.message = [
                    "Halo ".concat(recipientName, ",\n"),
                    "Saya telah berhasil bergabung dalam komunitas ".concat(communityName, "\n"),
                    "Stockbit Username: ".concat(username, "\n"),
                    "No. HP: ".concat(phone, "\n"),
                    "Mohon undang ke grup diskusi. Terima kasih!", 
                ].join(" \n");
            });
        },
        sendChat: function sendChat(param) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var hideShareModal;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            hideShareModal = get().hideShareModal;
                            _ctx.next = 3;
                            return chat/* default.sendBulkChat */.ZP.sendBulkChat(param);
                        case 3:
                            (0,AlertErrorMessage/* default */.Z)(successMessage/* default.POST_SHARED_SUCCESSFUL */.Z.POST_SHARED_SUCCESSFUL, successMessage/* default.SNACKBAR_GREEN */.Z.SNACKBAR_GREEN, true);
                            hideShareModal();
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        hideShareModal: function hideShareModal() {
            set(function(draft) {
                draft.isShareModalVisible = false;
                draft.recipientName = null;
                draft.message = null;
            });
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/community/components/Detail.tsx












function Detail(param) {
    var fee = param.fee, until = param.until, onLeave = param.onLeave, community = param.community, ableToLeave = param.ableToLeave;
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), _data = ref.data, phone = _data.phone, username = _data.username;
    var showModal = useShareReceipt(function(store) {
        return store.showShareModal;
    });
    var handleShareClick = function() {
        showModal(community.leader.username, community.name, username, phone);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            width: "400px",
            margin: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* DetailContainer */.Mv, {
            align: "center",
            justify: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "logo",
                    src: "images/community/active-hero.svg",
                    width: 180,
                    height: 140
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Fieldset, {
                    fee: fee,
                    community: community,
                    withProfile: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                    condition: !ableToLeave,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Info, {
                            until: until
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            mt: "16px",
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Next */.o6, {
                                width: "100%",
                                onClick: handleShareClick,
                                children: "Bagikan Bukti Aktivasi"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: ableToLeave,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonTransparent */.hb, {
                        onClick: onLeave,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            color: "rgba(238, 74, 73, 1)",
                            size: "14px",
                            height: "19px",
                            align: "center",
                            // @ts-expect-error
                            mt: "16px",
                            p: "12px",
                            children: "Keluar Komunitas"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_Detail = (Detail);

;// CONCATENATED MODULE: ./src/features/community/components/Modals/Leave.tsx





function Leave(param) {
    var onOk = param.onOk, visible = param.visible, onCancel = param.onCancel, communityName = param.communityName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Modal */.u_, {
        onOk: onOk,
        visible: visible,
        onCancel: onCancel,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/close.svg",
            width: "10px",
            height: "10px"
        }),
        width: 500,
        footer: [
            // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                justify: "space-between",
                mt: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Cancel */.$j, {
                        width: "50%",
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            size: "14px",
                            height: "19px",
                            children: "Batal"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Exit */.n$, {
                        width: "50%",
                        onClick: onOk,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            color: "white",
                            size: "14px",
                            height: "19px",
                            children: "Keluar"
                        })
                    })
                ]
            }), 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* ItemContainer */.om, {
            justify: "center",
            align: "center",
            mt: "60px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "leave",
                    src: "images/community/leave.svg",
                    width: 160,
                    height: 120
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    // @ts-expect-error
                    mt: "20px",
                    size: "18px",
                    height: "24.3px",
                    family: "bold",
                    align: "center",
                    mb: "12px",
                    children: "Keluar dari Komunitas?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    size: "14px",
                    height: "19px",
                    color: "rgba(133, 133, 133, 1)",
                    // @ts-expect-error
                    mb: "20px",
                    children: [
                        "Apakah kamu yakin keluar dari komunitas\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "".concat(communityName, "?")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Modals_Leave = (Leave);

// EXTERNAL MODULE: ./src/features/community/components/Template.tsx
var Template = __webpack_require__(28471);
;// CONCATENATED MODULE: ./src/features/community/components/Community.tsx








function Community(param) {
    var data = param.data, refetch = param.refetch;
    var ref = (0,react.useState)(false), confirm = ref[0], setConfirm = ref[1];
    var leaveCommunity = hooks_useLeaveCommunity();
    var onLeave = function() {
        analytics/* affiliateNavigationEvents.exitExternalCommunityViewed */.L.exitExternalCommunityViewed();
        analytics/* affiliateActions.exitCommunitySelected */.d.exitCommunitySelected();
        setConfirm(true);
    };
    var onCancel = function() {
        analytics/* affiliateActions.exitCommunityCanceled */.d.exitCommunityCanceled();
        setConfirm(false);
    };
    var onConfirm = function() {
        analytics/* affiliateActions.exitCommunityConfirmed */.d.exitCommunityConfirmed();
        leaveCommunity.mutate(undefined, {
            onSuccess: function onSuccess() {
                setConfirm(false);
                refetch();
            }
        });
    };
    (0,react.useEffect)(function() {
        analytics/* affiliateNavigationEvents.membersExternalCommunityViewed */.L.membersExternalCommunityViewed(data.able_to_leave);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-cy": DATA_CY_COMMUNITY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Template/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Detail, {
                    fee: data.community_fee || data.default_fee,
                    until: data.commit_until,
                    onLeave: onLeave,
                    community: data.community,
                    ableToLeave: data.able_to_leave
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_Leave, {
                onOk: onConfirm,
                visible: confirm,
                onCancel: onCancel,
                communityName: data.community.name
            })
        ]
    });
}
/* harmony default export */ var components_Community = (Community);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var store = __webpack_require__(70175);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
;// CONCATENATED MODULE: ./src/features/community/components/ReferralForm.tsx








function ReferralForm(param) {
    var error = param.error, onSubmit = param.onSubmit;
    var ref = (0,react.useState)(""), code = ref[0], setCode = ref[1];
    var onChangeCode = function(event) {
        setCode(event.target.value);
    };
    (0,react.useEffect)(function() {
        analytics/* affiliateNavigationEvents.externalCommunityViewed */.L.externalCommunityViewed();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: onSubmit,
        style: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* FormContainer */.Yb, {
            align: "flex-start",
            m: "0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "logo",
                    src: "images/community/hero.svg",
                    width: 180,
                    height: 140
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    // @ts-expect-error
                    mt: "24px",
                    size: "18px",
                    height: "24.3px",
                    family: "bold",
                    align: "center",
                    mb: "8px",
                    children: "Aktivasi Kode Komunitas"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "24px",
                    size: "14px",
                    height: "21px",
                    align: "center",
                    children: "Masukkan kode untuk mulai investasi bersama komunitas kamu."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* ItemContainer */.om, {
                    justify: "flex-start",
                    align: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Input */.II, {
                            id: "code",
                            name: "code",
                            value: code,
                            required: true,
                            // @ts-expect-error
                            status: error ? "error" : "",
                            onChange: onChangeCode,
                            placeholder: "Masukkan Kode Komunitas"
                        }),
                        error ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            size: "12px",
                            height: "16px",
                            family: "regular",
                            // @ts-expect-error
                            mt: "5px",
                            color: "#EE4A49",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "logo",
                                    src: "images/community/warning.svg",
                                    width: 16,
                                    height: 16,
                                    style: {
                                        marginTop: -2
                                    }
                                }),
                                " ",
                                "Kode komunitas tidak ditemukan"
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* ItemContainer */.om, {
                    justify: "center",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            size: "12px",
                            height: "16px",
                            family: "regular",
                            // @ts-expect-error
                            mb: "20px",
                            mt: "40px",
                            align: "center",
                            children: [
                                "Dengan menggunakan kode komunitas, saya mengerti dan menyetujui",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/community-rules",
                                    children: "Syarat & Ketentuan"
                                }),
                                " yang berlaku."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            htmlType: "submit",
                            type: "primary",
                            height: "36px",
                            disabled: code.length === 0,
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                color: "white",
                                children: "Lanjut"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var components_ReferralForm = (ReferralForm);

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
;// CONCATENATED MODULE: ./src/features/community/components/Modals/Confirm.tsx












function Confirm(param) {
    var _isRealTrading = param.isRealTrading, isRealTrading = _isRealTrading === void 0 ? false : _isRealTrading, fee = param.fee, onOk = param.onOk, title = param.title, until = param.until, visible = param.visible, onCancel = param.onCancel, community = param.community, communityFee = param.communityFee, _minBalance = param.minBalance, minBalance = _minBalance === void 0 ? 0 : _minBalance;
    var ref = (0,tradingData/* default */.Z)(), getPortfolio = ref.getPortfolio, _portfolio = ref.portfolio, tradingbalance = _portfolio.data.tradingbalance, isLoading = _portfolio.isLoading;
    var isSufficient = tradingbalance >= 0 && tradingbalance >= minBalance;
    var refetchPortfolio = function() {
        return getPortfolio(isRealTrading, true);
    };
    var renderAmount = function() {
        var amount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return amount >= 0 ? "Rp".concat(numeral_default()(Math.abs(Math.floor(amount))).format("0,0")) : "-Rp".concat(numeral_default()(Math.abs(Math.floor(amount))).format("0,0"));
    };
    (0,react.useEffect)(function() {
        if (isRealTrading) {
            refetchPortfolio();
        }
    }, [
        isRealTrading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* Modal */.u_, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "18px",
            align: "center",
            // @ts-expect-error
            pb: "18px",
            family: "bold",
            height: "24.3px",
            children: title
        }),
        onOk: onOk,
        onCancel: onCancel,
        visible: visible,
        width: 500,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/close.svg",
            width: "10px",
            height: "10px"
        }),
        footer: [
            // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                justify: "space-between",
                mt: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Cancel */.$j, {
                        width: "50%",
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            size: "14px",
                            height: "19px",
                            children: "Batal"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Next */.o6, {
                        width: "50%",
                        onClick: onOk,
                        disabled: !isSufficient,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            color: "white",
                            size: "14px",
                            height: "19px",
                            children: "Aktivasi"
                        })
                    })
                ]
            }), 
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* FieldsetGroup */.Y3, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Fieldset, {
                        fee: fee,
                        community: community,
                        communityFee: communityFee
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: minBalance > 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* FieldsetWrapper */.CG, {
                            tight: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justify: "space-between",
                                align: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justify: "flex-start",
                                                align: "center",
                                                mb: "4px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "Trading Balance"
                                                    }),
                                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* BalanceShimmer */.Oj, {}) : // @ts-expect-error
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        as: "strong",
                                                        color: isSufficient ? "#00AB6B" : "#EE4A49",
                                                        weight: "bold",
                                                        mx: "4px",
                                                        children: renderAmount(tradingbalance === 0 ? 0 : Number(tradingbalance))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                        condition: !isSufficient && !isLoading,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* RefreshButton */.ts, {
                                                            onClick: refetchPortfolio,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                src: "/icon/ic_refresh.svg"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                justify: "space-between",
                                                align: "flex-start",
                                                m: "0px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    as: "span",
                                                    size: "12px",
                                                    height: "16px",
                                                    color: "rgba(150, 150, 150, 1)",
                                                    children: [
                                                        "Min ",
                                                        renderAmount(minBalance),
                                                        " untuk bergabung"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !isSufficient,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/securities/deposit",
                                            target: "__blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* DepositButton */.Hq, {
                                                type: "outline-primary",
                                                children: "Deposit"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Info, {
                until: until
            })
        ]
    });
}
/* harmony default export */ var Modals_Confirm = (Confirm);

;// CONCATENATED MODULE: ./src/features/community/components/Modals/Done.tsx









function Done(param) {
    var onOk = param.onOk, leaderName = param.leaderName, name = param.name, visible = param.visible;
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), _data = ref.data, phone = _data.phone, username = _data.username;
    var showModal = useShareReceipt(function(store) {
        return store.showShareModal;
    });
    var handleShareClick = function() {
        showModal(leaderName, name, username, phone);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* Modal */.u_, {
        visible: visible,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/close.svg",
            width: "10px",
            height: "10px",
            style: {
                display: "none"
            }
        }),
        width: 500,
        title: // @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* ItemContainer */.om, {
            align: "center",
            justify: "center",
            mb: "40px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "18px",
                    height: "24.3px",
                    family: "bold",
                    align: "center",
                    children: "Aktivasi Kode"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: "18px",
                    height: "24.3px",
                    family: "bold",
                    align: "center",
                    children: "Komunitas Berhasil"
                })
            ]
        }),
        footer: [
            // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                justify: "center",
                mt: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        onClick: handleShareClick,
                        type: "outline-primary",
                        // @ts-expect-error
                        p: "12px",
                        mr: "8px",
                        radius: "4px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            color: "#00ab6b",
                            size: "14px",
                            height: "19px",
                            children: "Bagikan Bukti"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(community_styled/* Next */.o6, {
                        width: "100%",
                        onClick: onOk,
                        type: "outline-primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            color: "white",
                            size: "14px",
                            height: "19px",
                            children: "Selesai"
                        })
                    })
                ]
            }), 
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* ItemContainer */.om, {
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: "logo",
                        src: "images/community/hero.svg",
                        width: 180,
                        height: 140
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* ItemContainer */.om, {
                        align: "center",
                        justify: "center",
                        my: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "14px",
                                height: "21px",
                                align: "center",
                                children: "Berhasil bergabung dalam komunitas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "14px",
                                height: "21px",
                                family: "bold",
                                align: "center",
                                children: name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(community_styled/* FieldsetWrapper */.CG, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "flex-start",
                        mb: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Stockbit Username"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: username
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "No. HP"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: phone
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Modals_Done = (Done);

;// CONCATENATED MODULE: ./src/features/community/hooks/useJoinCommunity.ts




function useJoinCommunity() {
    var mutation = (0,useMutation/* useMutation */.D)({
        mutationFn: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(code) {
                var response, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,community/* postApplyReferral */.H5)(code);
                        case 2:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 5;
                                break;
                            }
                            throw new Error("Something is terribly wrong, please contact our administrator");
                        case 5:
                            data = response.data.data;
                            return _ctx.abrupt("return", data);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(code) {
                return _ref.apply(this, arguments);
            };
        }(),
        retry: false
    });
    return mutation;
}
/* harmony default export */ var hooks_useJoinCommunity = (useJoinCommunity);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
;// CONCATENATED MODULE: ./src/features/community/hooks/useGetCommunity.ts





function useGetCommunity(code) {
    var query = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "community",
            code
        ],
        enabled: false,
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,community/* getReferralByCode */.KT)(code);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Something is terribly wrong, please contact our administrator");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data.data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,errors/* errorHandler */.P)(_ctx.t0, "Failed to get community, unhandled error");
                        return _ctx.abrupt("return", undefined);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        })),
        retry: false
    });
    return query;
}
/* harmony default export */ var hooks_useGetCommunity = (useGetCommunity);

;// CONCATENATED MODULE: ./src/features/community/components/JoinCommunity.tsx













function JoinCommunity() {
    var ref, ref1, ref2, ref3;
    var showModal = (0,store/* default */.Z)(function(store) {
        return store.showModal;
    });
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var ref4 = (0,react.useState)(false), confirm = ref4[0], setConfirm = ref4[1];
    var ref5 = (0,react.useState)(""), code = ref5[0], setCode = ref5[1];
    var ref6 = (0,react.useState)(false), done = ref6[0], setDone = ref6[1];
    var router = (0,next_router.useRouter)();
    // A unique number to trigger `getCommunity.refetch`
    // whenever users click CTA because the same code got cached by react-query
    var ref7 = (0,react.useState)(0), rand = ref7[0], setRand = ref7[1];
    var getCommunity = hooks_useGetCommunity(code);
    var communityData = getCommunity.data;
    var joinCommunity = hooks_useJoinCommunity();
    var triggerConfirm = function(param) {
        var isSuccess = param.isSuccess;
        if (!isSuccess) {
            return;
        }
        if (isRealTrading) {
            setConfirm(true);
            analytics/* affiliateNavigationEvents.confirmedCodeCommunityViewed */.L.confirmedCodeCommunityViewed(code);
            return;
        }
        showModal();
    };
    var onDone = function() {
        var ref, ref1;
        analytics/* affiliateActions.activatedCodeSuccessSelected */.d.activatedCodeSuccessSelected(code);
        setDone(false);
        var room_id = ((joinCommunity === null || joinCommunity === void 0 ? void 0 : (ref = joinCommunity.data) === null || ref === void 0 ? void 0 : (ref1 = ref.community) === null || ref1 === void 0 ? void 0 : ref1.chat) || {}).room_id;
        var url = room_id ? "/group-chat/".concat(room_id) : "/stream";
        router.push(url);
    };
    var onSubmit = function(event) {
        event.preventDefault();
        var formData = new FormData(event.currentTarget);
        var codeFromParams = formData.get("code");
        analytics/* affiliateActions.activatedCodeSelected */.d.activatedCodeSelected(codeFromParams);
        setCode(codeFromParams);
        setRand(Math.random());
    };
    var onConfirm = function() {
        analytics/* affiliateActions.activatedCodeConfirmed */.d.activatedCodeConfirmed(code);
        joinCommunity.mutate(code, {
            onSuccess: function onSuccess() {
                setConfirm(false);
                setDone(true);
                analytics/* affiliateNavigationEvents.activatedSuccessCodeCommunityViewed */.L.activatedSuccessCodeCommunityViewed(code);
            }
        });
    };
    var onCancel = function() {
        analytics/* affiliateActions.activatedCodeCanceled */.d.activatedCodeCanceled(code);
        setConfirm(false);
    };
    (0,react.useEffect)(function() {
        if (code.length > 0) {
            getCommunity.refetch().then(triggerConfirm);
        }
    }, [
        code,
        rand,
        isRealTrading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-cy": DATA_CY_JOIN_COMMUNITY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Template/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReferralForm, {
                    error: getCommunity.isError,
                    onSubmit: onSubmit
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_Confirm, {
                isRealTrading: isRealTrading,
                fee: communityData === null || communityData === void 0 ? void 0 : communityData.default_fee,
                onOk: onConfirm,
                title: "Konfirmasi Kode Komunitas",
                until: communityData === null || communityData === void 0 ? void 0 : communityData.commit_until,
                visible: confirm && !getCommunity.isError,
                onCancel: onCancel,
                community: communityData === null || communityData === void 0 ? void 0 : communityData.community,
                communityFee: communityData === null || communityData === void 0 ? void 0 : communityData.community_fee,
                minBalance: Number(communityData === null || communityData === void 0 ? void 0 : communityData.community.minimum_balance)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_Done, {
                onOk: onDone,
                name: communityData === null || communityData === void 0 ? void 0 : (ref = communityData.community) === null || ref === void 0 ? void 0 : ref.name,
                leaderName: joinCommunity === null || joinCommunity === void 0 ? void 0 : (ref1 = joinCommunity.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.community) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.leader) === null || ref3 === void 0 ? void 0 : ref3.username,
                visible: done
            })
        ]
    });
}
/* harmony default export */ var components_JoinCommunity = (JoinCommunity);

;// CONCATENATED MODULE: ./src/features/community/hooks/useCheckStatus.ts





function useCheckStatus() {
    var query = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "communityStatus"
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,community/* getReferralStatus */.ER)();
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Something is terribly wrong, please contact our administrator");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data.data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,errors/* errorHandler */.P)(_ctx.t0, "Failed to check status, unhandled error");
                        return _ctx.abrupt("return", undefined);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        })),
        retry: false
    });
    return query;
}
/* harmony default export */ var hooks_useCheckStatus = (useCheckStatus);

;// CONCATENATED MODULE: ./src/features/community/index.tsx








function CommunityFeature() {
    var ref = hooks_useCheckStatus(), data = ref.data, refetch = ref.refetch, isError = ref.isError, isSuccess = ref.isSuccess, isLoading = ref.isLoading, isFetching = ref.isFetching;
    var isVisible = useShareReceipt(function(store) {
        return store.isShareModalVisible;
    });
    var recipientName = useShareReceipt(function(store) {
        return store.recipientName;
    });
    var message = useShareReceipt(function(store) {
        return store.message;
    });
    var sendChat = useShareReceipt(function(store) {
        return store.sendChat;
    });
    var hideShareModal = useShareReceipt(function(store) {
        return store.hideShareModal;
    });
    if (!isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                    condition: isSuccess,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Community, {
                            data: data,
                            refetch: refetch
                        }),
                        ";"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isError,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_JoinCommunity, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare["default"], {
                    onCancel: hideShareModal,
                    sendChat: sendChat,
                    title: "Share",
                    recipientName: recipientName,
                    visible: isVisible,
                    defaultSharedMessage: message,
                    hasSingleRecipient: true
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimarySpinner/* default */.Z, {
        isLoading: isFetching || isLoading,
        overlay: true,
        isDarkOverlay: true
    });
}
/* harmony default export */ var features_community = (CommunityFeature);


/***/ }),

/***/ 99890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ Cancel; },
/* harmony export */   "CG": function() { return /* binding */ FieldsetWrapper; },
/* harmony export */   "HZ": function() { return /* binding */ TemplateHeader; },
/* harmony export */   "Hq": function() { return /* binding */ DepositButton; },
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "Mv": function() { return /* binding */ DetailContainer; },
/* harmony export */   "Oj": function() { return /* binding */ BalanceShimmer; },
/* harmony export */   "Y3": function() { return /* binding */ FieldsetGroup; },
/* harmony export */   "Yb": function() { return /* binding */ FormContainer; },
/* harmony export */   "fM": function() { return /* binding */ TemplateLayout; },
/* harmony export */   "mo": function() { return /* binding */ InfoWrapper; },
/* harmony export */   "n$": function() { return /* binding */ Exit; },
/* harmony export */   "o6": function() { return /* binding */ Next; },
/* harmony export */   "om": function() { return /* binding */ ItemContainer; },
/* harmony export */   "qz": function() { return /* binding */ TemplateContent; },
/* harmony export */   "ts": function() { return /* binding */ RefreshButton; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* unused harmony export MemberTable */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79931);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  justify-content: center;\n  max-width: 798px;\n  background: white;\n  margin: 0 auto;\n  margin-top: 30px;\n  margin-bottom: 100px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 52px;\n  border-bottom: 1px solid ",
        ";\n  width: 100%;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 135%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 40px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100% !important;\n  border: 1px solid rgba(237, 237, 237, 1);\n  border-radius: 4px;\n\n  text-align: center;\n\n  ",
        "\n\n  input {\n    font-size: 14px;\n    line-height: 19px;\n    font-family: 'ProximaNovaLt';\n    color: rgba(51, 51, 51, 1);\n\n    &::placeholder {\n      font-family: 'ProximaNovaLt';\n      color: rgba(181, 181, 181, 1);\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: 100%;\n\n  a {\n    font-weight: bold;\n  }\n\n  .ant-btn-primary[disabled] {\n    background-color: rgba(204, 238, 225, 1) !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  height: 520px;\n  max-width: 400px;\n  margin: auto;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 6px;\n  background-color: rgba(242, 241, 254, 1);\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: 100%;\n  height: 520px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 40px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: ",
        ";\n  border: 1px solid rgba(237, 237, 237, 1);\n  border-radius: 4px;\n\n  .grey {\n    color: rgba(181, 181, 181, 1);\n  }\n\n  .line-through {\n    text-decoration: line-through;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n    padding: 24px 40px 40px 40px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid rgba(237, 237, 237, 1);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :disabled {\n    background-color: #cceee1 !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid rgba(238, 74, 73, 1);\n  p {\n    color: rgba(238, 74, 73, 1);\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  outline: none;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 4px;\n  height: 16px;\n  width: 96px;\n  background-color: #f7f7f7;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px 12px;\n  width: 100%;\n\n  .ant-table-column-sorters-with-tooltip,\n  .ant-table-column-sorters {\n    display: flex;\n    justify-content: ",
        ";\n    padding: 0;\n\n    .ant-table-column-sorter {\n      display: flex;\n      margin-top: 0;\n    }\n  }\n\n  & .ant-table {\n    thead {\n      th {\n        background-color: transparent;\n        padding: 6px 5px;\n      }\n\n      th:first-of-type {\n        padding-left: 0;\n      }\n\n      th:last-of-type {\n        padding-right: 0;\n      }\n    }\n\n    tbody {\n      td {\n        overflow-wrap: normal;\n        padding: 6px 5px;\n      }\n\n      td:first-of-type {\n        padding-left: 0;\n      }\n\n      td:last-of-type {\n        padding-right: 0;\n      }\n    }\n\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td {\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}







var TemplateLayout = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
var TemplateHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
var TemplateContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-2"
})(_templateObject2());
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    p: "12px"
}).withConfig({
    componentId: "sc-ae805254-3"
})(_templateObject3(), // @ts-expect-error
function(param) {
    var status = param.status;
    if (status !== "error") {
        return "";
    }
    return "\n        border: 1px solid #EE4A49;\n\n        &:hover,\n        &:focus,\n        &:active {\n          border: 1px solid #EE4A49;\n        }\n      ";
});
var ItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-4"
})(_templateObject4());
var FormContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-5"
})(_templateObject5());
var InfoWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-6"
})(_templateObject6());
var DetailContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-7"
})(_templateObject7());
var FieldsetGroup = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ae805254-8"
})(_templateObject8());
var FieldsetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].fieldset.withConfig */ .ZP.fieldset.withConfig({
    componentId: "sc-ae805254-9"
})(_templateObject9(), function(param) {
    var tight = param.tight;
    return tight ? "12px 16px" : "16px";
});
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-10"
})(_templateObject10());
var Cancel = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    type: "link",
    radius: "4px",
    p: "12px",
    mr: "8px"
}).withConfig({
    componentId: "sc-ae805254-11"
})(_templateObject11());
var Next = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    radius: "4px",
    p: "12px",
    mr: "8px",
    type: "primary"
}).withConfig({
    componentId: "sc-ae805254-12"
})(_templateObject12());
var DepositButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    radius: "4px",
    mr: "0px",
    px: "12px",
    // @ts-expect-error
    type: "outline-primary"
}).withConfig({
    componentId: "sc-ae805254-13"
})(_templateObject13());
var Exit = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    type: "link",
    radius: "4px",
    p: "12px",
    mr: "8px"
}).withConfig({
    componentId: "sc-ae805254-14"
})(_templateObject14());
var RefreshButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    // @ts-expect-error
    type: "button",
    radius: "0px",
    p: "0px"
}).withConfig({
    componentId: "sc-ae805254-15"
})(_templateObject15());
var BalanceShimmer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ae805254-16"
})(_templateObject16());
var MemberTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ae805254-17"
})(_templateObject17(), function(param) {
    var alignSorter = param.alignSorter;
    return alignSorter === "start" ? "flex-start" : "flex-end";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].aliceBlue */ .Z.aliceBlue);


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 32253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29658);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 100px;\n  min-height: 100px;\n  position: relative;\n\n  @keyframes spinner {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  &::before {\n    content: 'Loading…';\n    position: absolute;\n    top: calc(50% - 15px);\n    left: calc(50% - 15px);\n    width: 30px;\n    height: 30px;\n    margin-top: 0;\n    margin-left: 0;\n    content: '';\n    border-radius: 50%;\n    border-top: 4px solid #00ab6b;\n    border-right: 4px solid transparent;\n    animation: 0.7s linear infinite spinner;\n    -webkit-animation: 0.7s linear infinite spinner;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PrimarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-717be61e-0"
})(_templateObject(), function(param) {
    var overlay = param.overlay, isDarkOverlay = param.isDarkOverlay;
    return overlay && "\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 100;\n    background: ".concat(isDarkOverlay ? "rgba(0,0,0,.5)" : "rgba(255,255,255,.85)", ";\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ");
});
var PrimarySpinner = function(_param) {
    var overlay = _param.overlay, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "overlay",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PrimarySpinnerDiv, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            "data-cy": "primary-spinner",
            overlay: overlay
        }, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrimarySpinner);


/***/ }),

/***/ 73164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gi": function() { return /* binding */ SymbolLinkWrapper; },
/* harmony export */   "Hl": function() { return /* binding */ WidgetContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "bW": function() { return /* binding */ ButtonWidget; },
/* harmony export */   "hb": function() { return /* binding */ ButtonTransparent; },
/* harmony export */   "wv": function() { return /* binding */ WidgetWrapper; },
/* harmony export */   "xw": function() { return /* binding */ HumbergerButton; }
/* harmony export */ });
/* unused harmony export Box */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var re_resizable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46312);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_widget_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89999);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-left: 1px solid ",
        ";\n  border-collapse: collapse;\n  box-sizing: border-box;\n  height: 100%;\n  width: 48px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  display: none;\n  z-index: 999;\n  gap: 0;\n  @media ",
        " {\n    height: 100vh;\n    display: flex;\n    position: fixed;\n    top: 0;\n    right: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 100%;\n    border: ",
        ";\n    border-right: none;\n    overflow-y: hidden;\n    width: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  z-index: 99;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n\n  &:hover,\n  &:focus {\n    background: none;\n    border: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n\n      .icon-widget_runningtrade::before {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      &:after {\n        content: '';\n        display: block;\n        height: 5px;\n        width: 5px;\n        background: ",
        ";\n        position: absolute;\n        top: 21px;\n        right: 8px;\n        border-radius: 50%;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #fff;\n  color: #969696;\n  border: none;\n  border-bottom: 1px solid #dadada;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 66px;\n  position: relative;\n  width: 48px;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n\n  .icon-menu_calendar {\n    color: #6b6b6b;\n    ",
        "\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: inherit;\n\n  &:hover {\n    color: inherit;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-73a3804d-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
var WidgetContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-73a3804d-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].tablet */ .Z.tablet);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73a3804d-2"
})(function(param) {
    var isOpen = param.isOpen, isMarketOpen = param.isMarketOpen;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2(), isOpen ? "1px solid #DADADA" : 0, isOpen ? isMarketOpen ? "331px" : "390px" : 0);
});
var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(re_resizable__WEBPACK_IMPORTED_MODULE_1__/* .Resizable */ .e).attrs({
    enable: {
        top: false,
        right: false,
        bottom: true,
        left: false,
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false
    }
}).withConfig({
    componentId: "sc-73a3804d-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light);
var ButtonTransparent = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-73a3804d-4"
})(_templateObject4());
var HumbergerButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_widget_Button__WEBPACK_IMPORTED_MODULE_4__/* .HumbergerButton */ .x).withConfig({
    componentId: "sc-73a3804d-5"
})(_templateObject6(), function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
});
var ButtonWidget = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-73a3804d-6"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary);
}, function(param) {
    var $shouldRenderAfter = param.$shouldRenderAfter;
    return $shouldRenderAfter && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary);
}, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary);
});
var SymbolLinkWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-73a3804d-7"
})(_templateObject11());



/***/ }),

/***/ 97486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Update debounced value after delay
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ })

}]);